<template>
    <v-tooltip
        top
        :disabled="disableTooltip || $vuetify.breakpoint.smAndUp"
    >
        <template v-slot:activator="{ on }">
            <v-btn
                color="primary"
                dark
                text
                :small="$vuetify.breakpoint.xsOnly"
                :large="$vuetify.breakpoint.smAndUp"
                class="link-button text-none"
                :href="disableLink ? null : link.url"
                target="_blank"
                v-on="on"
                @click="$emit('click', $event)"
                :max-width="maxWidth"
                :disabled="textOnly"
            >
                <icon-base
                    class="link-icon"
                    :icon-name="iconName"
                    width="20px"
                    height="20px"
                />
                <span
                    :class="{
                        'button-text': true,
                        'text-truncate': true,
                        'text-only': textOnly
                    }"
                >
                    {{ link.text }}
                </span>
            </v-btn>
        </template>
        <span class="link-tooltip-text">{{ link.text }}</span>
    </v-tooltip>
</template>

<script>
import IconBase from '../../components/IconBase'
import { IconMap } from '../../utils/iconList'

export default {
    components: {
        IconBase
    },
    props: {
        link: {
            type: Object,
            required: true
        },
        disableLink: {
            type: Boolean,
            default: false
        },
        disableTooltip: {
            type: Boolean,
            default: false
        },
        textOnly: {
            type: Boolean,
            default: false
        },
        maxWidth: {
            type: [String, Number],
            default: 'auto'
        }
    },
    computed: {
        iconName: function () {
            if (
                this.link
                && this.link.type
                && IconMap.hasOwnProperty(this.link.type)
            ) {
                return IconMap[this.link.type].icon
            } else {
                // TODO - replace with default link icon or CC icon
                return 'facebook'
            }
        }
        // currently unused
        // linkColor: function () {
        //     if (
        //         this.link
        //         && this.link.type
        //         && IconMap.hasOwnProperty(this.link.type)
        //         && IconMap[this.link.type].color
        //     ) {
        //         return IconMap[this.link.type].color
        //     } else {
        //         return 'primary'
        //     }
        // }
    }
}
</script>

<style lang="scss">
.link-button {
    .v-btn__content {
        max-width: 100%;
    }
}
.link-icon {
    margin-right: 12px;
}
.link-tooltip-text {
    letter-spacing: 0.089em;
}
.text-only {
    color: #000;
}
</style>
